var common = {
  black: '#000',
  white: '#fff'
};
export default common;


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/esm/colors/common.js
// module id = 859
// module chunks = 2